// extracted by mini-css-extract-plugin
export default {"more-btn-container":"restosList_more-btn-container__SX-aU","image":"restosList_image__u5+pg"};